// src/components/admin/UnsupportedViewport.tsx
import { PlatformFooter } from '@/components/common/PlatformFooter';
import { MyndwellMark } from '@/components/ui/brand-mark';
import { adminCopy } from '@/lib/copy';

export function UnsupportedViewport() {
  return (
    <div className="bg-background flex min-h-screen flex-col px-6 py-12">
      <div className="flex flex-1 items-center justify-center">
        <div className="bg-surface flex max-w-md flex-col items-center gap-6 rounded-xl border p-8 text-center shadow-xs">
          <MyndwellMark size="md" tone="ink" />
          <div className="space-y-2">
            <h1 className="font-display text-display-lg text-accent-ink">
              {adminCopy.viewport.unsupportedTitle}
            </h1>
            <p className="text-body-md text-neutral-500">
              {adminCopy.viewport.unsupportedDescription}
            </p>
          </div>
        </div>
      </div>
      <PlatformFooter className="mx-auto w-full max-w-md" />
    </div>
  );
}
